import React from 'react';

/**
 * Keeps dashboard tab content mounted but hidden when inactive (instant tab switches).
 */
const DashboardTabPanel = ({ tabId, activeTab, children }) => {
  const isActive = activeTab === tabId;

  if (!children) {
    return null;
  }

  return (
    <div
      id={`dashboard-tabpanel-${tabId}`}
      role="tabpanel"
      aria-labelledby={`dashboard-tab-${tabId}`}
      hidden={!isActive}
      className={
        isActive
          ? 'block min-w-0'
          : 'hidden min-w-0 [content-visibility:hidden]'
      }
    >
      {children}
    </div>
  );
};

export default React.memo(DashboardTabPanel);
